// extracted by mini-css-extract-plugin
module.exports = {"faqSection__inner":"FaqSection_faqSection__inner__8bigY","faqSection__text":"FaqSection_faqSection__text__4zvpm","faqSection":"FaqSection_faqSection__kB9ey"};